import {
  ShopFeatureEvent,
  TrackingCoreOverlayTypes,
} from '../../../types/tracking-core-events-type';
import {WithOptionalTypes} from '../helpers/withOptionalTypes';

// Parameters accepted by the factory: all properties of an overlay event
// except the `event` field which will be set by the factory.
type TrackOverlayParams = Omit<
  TrackingCoreOverlayTypes,
  'event' | 'abtest_flag'
>;

type TrackOverlayParamsPartial = WithOptionalTypes<
  TrackOverlayParams,
  'sponsored' | 'page_type_id' | 'event_scope'
>;

export const trackOverlay =
  (params: TrackOverlayParamsPartial) =>
  (): ShopFeatureEvent<TrackingCoreOverlayTypes> => ({
    GA4: {
      ...params,
      event: 'overlay',
      abtest_flag: false,
      event_scope: params.event_scope ?? 'long',
      page_type_id: params.page_type_id ?? '',
    },
  });
